module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/474.068dad5b.png";